import type { LanguageTexts } from './types';

export const en: LanguageTexts = {
  consentTitle: 'Cookies on this site',
  consentDescription:
    'We use necessary cookies that the site needs to work. With your consent, we would also use cookies for {purposes}, including cookies from third parties. You can change or withdraw your choice at any time with the button in the bottom corner of the page.',
  consentDescriptionNecessaryOnly:
    'We only use necessary cookies that the site needs to work. They do not require your consent.',
  controllerLine: 'Controller: {controller}.',
  acceptAll: 'Accept all',
  rejectAll: 'Reject all',
  preferences: 'Settings',
  save: 'Save choice',
  close: 'Close',
  serviceCounter: 'service|services',
  preferencesTitle: 'Cookie settings',
  introTitle: 'How we use cookies',
  introDescription:
    'Cookies are small files a website stores in your browser. Choose below which ones you allow. Necessary cookies are always on.',
  necessaryTitle: 'Necessary cookies',
  necessaryDescription:
    'Required for the site to work securely and to remember your cookie choice. They do not require consent.',
  categories: {
    functional: {
      title: 'Functional cookies',
      description: 'Enable extra features, such as embedded maps and remembered settings.',
      purpose: 'extra features',
    },
    analytics: {
      title: 'Analytics cookies',
      description:
        'Help us understand how visitors use the site (for example, which pages are visited most) so we can improve it.',
      purpose: 'measuring visits',
    },
    marketing: {
      title: 'Advertising cookies',
      description:
        'Used by advertising partners and providers of embedded content (such as videos) to show more relevant ads and measure their performance. They may track your visits to other sites.',
      purpose: 'advertising',
    },
  },
  moreTitle: 'More information',
  moreDescription: 'Read more about cookies and your rights in our {policyLink}.',
  policyLinkText: 'cookie policy',
  policyTitle: 'Cookie policy',
  and: 'and',
  poweredBy: 'Powered by',
  revisitLabel: 'Cookie settings',
  iframeNotice: 'Showing this content requires consent to “{category}”.',
  iframeButton: 'Allow and show',
  tableName: 'Cookie',
  tableProvider: 'Provider',
  tablePurpose: 'Purpose',
  tableDuration: 'Duration',
  session: 'Session',
  consentCookiePurpose: 'Stores your cookie choice.',
  otherCookiesTitle: 'Other cookies',
  otherCookiesNote: 'Cookies on this site that Kockica does not recognise. Contact the controller for details.',
  noCookies: 'No cookies that need consent were detected on this page.',
};
